import { Button } from '@material-ui/core';
import PropTypes from 'prop-types';
import React from 'react';

const GroupButton = ({ children, size, onClick }) => {
  return (
    <Button className="group-button" size={size} disableRipple onClick={onClick}>
      {children}
    </Button>
  );
};

GroupButton.propTypes = {
  children: PropTypes.node.isRequired,
  size: PropTypes.oneOf(['small', 'medium', 'large']),
  onClick: PropTypes.func.isRequired
};

GroupButton.defaultProps = {
  size: 'large'
};

export default GroupButton;
